import { isBrand, isDev, isProd, isStaging } from "../../global/environmentVariables";
import HomeBanana from "./HomeBanana";
import HomeBCPDev from "./HomeBCPDev";
import HomeBCPProd from "./HomeBCPProd";
import HomeCatan from "./HomeCatan";
import HomeChronoCore from "./HomeChronoCore";
import HomeDefault from "./HomeDefault";
import HomePrimal from "./HomePrimal";
import HomeShardBugs from "./HomeShardBugs";
import HomeSoulMasters from "./HomeSoulMasters";
import HomeStarcraft from "./HomeStarcraft";
import HomeUnplug from "./HomeUnplug";
import HomeWarhammer from "./HomeWarhammer";
import HomeWarmachine from "./HomeWarmachine";

export default function Home() {
  if (isBrand("bcp") && (isProd() || isStaging())) {
    return <HomeBCPProd />;
  }
  if (isBrand("catan")) {
    return <HomeCatan />;
  }

  if (isBrand("bananagrams")) {
    return <HomeBanana />;
  }

  if (isBrand("uy")) {
    return <HomeUnplug />;
  }

  if (isBrand("primal")) {
    return <HomePrimal />;
  }
  if (isBrand("wm")) {
    return <HomeWarmachine />;
  }
  if (isBrand("shard-bugs")) {
    return <HomeShardBugs />;
  }
  if (isBrand("soul-masters")) {
    return <HomeSoulMasters />;
  }
  if (isBrand("chrono-core")) {
    return <HomeChronoCore />;
  }
  if (isBrand("gw")) {
    return <HomeWarhammer />;
  }

  if (isBrand("starcraft")) {
    return <HomeStarcraft />;
  }

  if (isBrand("bcp") && isDev()) {
    return <HomeBCPDev />;
  }

  return <HomeDefault />;
}
